module.exports = __webpack_public_path__ + "img/fish-made-simple.85c34923.jpg";